// @ts-nocheck

export const localeCodes =  [
  "DK",
  "DU",
  "EN",
  "ES",
  "FI",
  "FR",
  "HU",
  "NL",
  "PL",
  "RU",
  "SK"
]
export const localeLoaders = {
  DK: [
    {
      key: "locale_dk_46json_4eb63b6d",
      load: () => import("#nuxt-i18n/4eb63b6d" /* webpackChunkName: "locale_dk_46json_4eb63b6d" */),
      cache: true
    }
  ],
  DU: [
    {
      key: "locale_du_46json_edac26de",
      load: () => import("#nuxt-i18n/edac26de" /* webpackChunkName: "locale_du_46json_edac26de" */),
      cache: true
    }
  ],
  EN: [
    {
      key: "locale_en_46json_86b98def",
      load: () => import("#nuxt-i18n/86b98def" /* webpackChunkName: "locale_en_46json_86b98def" */),
      cache: true
    }
  ],
  ES: [
    {
      key: "locale_es_46json_d99d7d9b",
      load: () => import("#nuxt-i18n/d99d7d9b" /* webpackChunkName: "locale_es_46json_d99d7d9b" */),
      cache: true
    }
  ],
  FI: [
    {
      key: "locale_fi_46json_cd60b075",
      load: () => import("#nuxt-i18n/cd60b075" /* webpackChunkName: "locale_fi_46json_cd60b075" */),
      cache: true
    }
  ],
  FR: [
    {
      key: "locale_fr_46json_964e21fb",
      load: () => import("#nuxt-i18n/964e21fb" /* webpackChunkName: "locale_fr_46json_964e21fb" */),
      cache: true
    }
  ],
  HU: [
    {
      key: "locale_hu_46json_21e24aff",
      load: () => import("#nuxt-i18n/21e24aff" /* webpackChunkName: "locale_hu_46json_21e24aff" */),
      cache: true
    }
  ],
  NL: [
    {
      key: "locale_nl_46json_cadf40c3",
      load: () => import("#nuxt-i18n/cadf40c3" /* webpackChunkName: "locale_nl_46json_cadf40c3" */),
      cache: true
    }
  ],
  PL: [
    {
      key: "locale_pl_46json_eb2425b7",
      load: () => import("#nuxt-i18n/eb2425b7" /* webpackChunkName: "locale_pl_46json_eb2425b7" */),
      cache: true
    }
  ],
  RU: [
    {
      key: "locale_ru_46json_f560a150",
      load: () => import("#nuxt-i18n/f560a150" /* webpackChunkName: "locale_ru_46json_f560a150" */),
      cache: true
    }
  ],
  SK: [
    {
      key: "locale_sk_46json_63b0a25c",
      load: () => import("#nuxt-i18n/63b0a25c" /* webpackChunkName: "locale_sk_46json_63b0a25c" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/f92ed8e6" /* webpackChunkName: "config_i18n_46config_46ts_f92ed8e6" */)
]
export const normalizedLocales = [
  {
    code: "DK",
    language: undefined
  },
  {
    code: "DU",
    language: undefined
  },
  {
    code: "EN",
    language: undefined
  },
  {
    code: "ES",
    language: undefined
  },
  {
    code: "FI",
    language: undefined
  },
  {
    code: "FR",
    language: undefined
  },
  {
    code: "HU",
    language: undefined
  },
  {
    code: "NL",
    language: undefined
  },
  {
    code: "PL",
    language: undefined
  },
  {
    code: "RU",
    language: undefined
  },
  {
    code: "SK",
    language: undefined
  }
]

